import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getRequestFoodMeal, emptyRequestFoodMeal} from './Module';
import {Form, Select as SelectInput} from 'antd';
import jMoment from 'components/classes/Jmomen';
import uuidv1 from 'uuid/v1';
import MaterialIcon from 'components/common/MaterialIcon';

@connect((state) => ({
  foodMeal: state.FormBuilder.Common.SelectFoodMeal.foodMeal,
}), {
  getRequestFoodMeal,
  emptyRequestFoodMeal,
})
@autobind
/**
 *
 */
export default class SelectFoodMealInfo extends React.PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    foodMealId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    foodMeal: PropTypes.object,
    getRequestFoodMeal: PropTypes.func,
    emptyRequestFoodMeal: PropTypes.func,
  };

  static defaultProps = {
    inline: true,
    label: undefined,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      foodMeal: {},
      render: true,
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {getRequestFoodMeal} = this.props;
    getRequestFoodMeal(this.props.foodMealId, {}, (r) => {
      this.setState({foodMeal:  r && r.data && r.data.meal});
    });
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(np.foodMealId, this.props.foodMealId)) {
      np.getRequestFoodMeal(np.foodMealId, {
      }, (r) => {
        this.setState({foodMeal: r && r.data && r.data.meal});

      });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyRequestFoodMeal();
  }


  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const {inline} = this.props;

    if (inline) {
      return {
        labelCol: {span: 6},
        wrapperCol: {span: 18},
      };
    }

    return {};
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {foodMeal} = this.state;
    return (
      <span>
        {`${foodMeal && foodMeal.title}`}
        </span>
    );
  }
}
